import { useRef, useMemo } from 'react';

/**
 * Used to obtain a constant reference to a changing callback.
 * This is useful for example when you are passing a function that uses local state to a third party library config.
 * On subsequent re-renders of the component, the third-party will typically not be re-configured and as such will
 * still have a reference to a stale version of the function.
 *
 * @param {function} fn callback
 * @return return value of fn
 */
export default function useConstantRefCallback(fn) {
  const callbackRef = useRef(fn);
  callbackRef.current = fn;

  const handler = useMemo(
    () =>
      function constantRefCallbackWrapper(...args) {
        if (callbackRef.current) {
          return callbackRef.current.apply(this, args);
        }

        return undefined;
      },
    [callbackRef],
  );

  return handler;
}
